import { atom } from 'recoil';

import { Atoms } from '../constants';

export const filterLabelIdsAtom = atom<number[]>({
  key: Atoms.filterLabelIds,
  default: [],
});
